import { geoFormModelToGeo, geoToGeoFormModel } from '../../../geo/components/form-geo-field/mappers';
import { Legal } from '../../../providers/api/dtos';
import { WizardCompanyFormModel } from './WizardCompanyForm';

export const legalToWizardCompanyFormModel = (legal?: Legal): WizardCompanyFormModel => ({
  companyName: legal?.companyName || '',
  companyAddress: geoToGeoFormModel(legal?.registeredOffice),
  companyFiscalCode: legal?.fiscalCode || '',
});

export const wizardCompanyFormModelToLegal = (values: WizardCompanyFormModel): Legal => ({
  companyName: values.companyName || undefined,
  fiscalCode: values.companyFiscalCode || undefined,
  registeredOffice: values.companyAddress ? geoFormModelToGeo(values.companyAddress) : undefined,
});
